const diving = require("@/assets/stamp/stamp-diving.png");
const communication = require("@/assets/stamp/stamp-communication.png");
const diy = require("@/assets/stamp/stamp-diy.png");
const event = require("@/assets/stamp/stamp-event.png");
const fishAutumn = require("@/assets/stamp/stamp-fish-autumn.png");
const fishSpring = require("@/assets/stamp/stamp-fish-spring.png");
const fishSummer = require("@/assets/stamp/stamp-fish-summer.png");
const fishWinter = require("@/assets/stamp/stamp-fish-winter.png");
const fish = require("@/assets/stamp/stamp-fish.png");
const fishingTourney = require("@/assets/stamp/stamp-fishing-tourney.png");
const fruitRootsCherry = require("@/assets/stamp/stamp-fruit-roots-cherry.png");
const fruitRootsCoconut = require("@/assets/stamp/stamp-fruit-roots-coconut.png");
const fruitRootsOrange = require("@/assets/stamp/stamp-fruit-roots-orange.png");
const fruitRootsPeach = require("@/assets/stamp/stamp-fruit-roots-peach.png");
const fruitRootsPear = require("@/assets/stamp/stamp-fruit-roots-pear.png");
const goldenMilestoneAxe = require("@/assets/stamp/stamp-golden-milestone-axe.png");
const goldenMilestoneCan = require("@/assets/stamp/stamp-golden-milestone-can.png");
const goldenMilestoneFishing = require("@/assets/stamp/stamp-golden-milestone-fishing.png");
const goldenMilestoneNet = require("@/assets/stamp/stamp-golden-milestone-net.png");
const goldenMilestoneShot = require("@/assets/stamp/stamp-golden-milestone-shot.png");
const goldenMilestoneShovel = require("@/assets/stamp/stamp-golden-milestone-shovel.png");
const hha = require("@/assets/stamp/stamp-hha.png");
const insectAug = require("@/assets/stamp/stamp-insect-aug.png");
const insectJul = require("@/assets/stamp/stamp-insect-jul.png");
const insectJun = require("@/assets/stamp/stamp-insect-jun.png");
const insectSep = require("@/assets/stamp/stamp-insect-sep.png");
const insect = require("@/assets/stamp/stamp-insect.png");
const islandDesignerBlue = require("@/assets/stamp/stamp-island-designer-blue.png");
const islandDesignerBrown = require("@/assets/stamp/stamp-island-designer-brown.png");
const islandDesignerGreen = require("@/assets/stamp/stamp-island-designer-green.png");
const islandNameIconsFlag = require("@/assets/stamp/stamp-island-name-icons-flag.png");
const islandNameIconsMelody = require("@/assets/stamp/stamp-island-name-icons-melody.png");
const landmaking = require("@/assets/stamp/stamp-landmaking.png");
const money = require("@/assets/stamp/stamp-money.png");
const mydesign = require("@/assets/stamp/stamp-mydesign.png");
const negative = require("@/assets/stamp/stamp-negative.png");
const plant = require("@/assets/stamp/stamp-plant.png");
const shrubberyHubbery = require("@/assets/stamp/stamp-shrubbery-hubbery.png");
const smartphone = require("@/assets/stamp/stamp-smartphone.png");
const cooking = require("@/assets/stamp/stamp-cooking.png");
const vegetable = require("@/assets/stamp/stamp-vegetable.png");
const hotel = require("@/assets/stamp/stamp-hotel.png");

export default {
  data() {
    return {
      stampUrls: {
        diving,
        communication,
        diy,
        event,
        fishAutumn,
        fishSpring,
        fishSummer,
        fishWinter,
        fish,
        fishingTourney,
        fruitRootsCherry,
        fruitRootsCoconut,
        fruitRootsOrange,
        fruitRootsPeach,
        fruitRootsPear,
        goldenMilestoneAxe,
        goldenMilestoneCan,
        goldenMilestoneFishing,
        goldenMilestoneNet,
        goldenMilestoneShot,
        goldenMilestoneShovel,
        hha,
        insectAug,
        insectJul,
        insectJun,
        insectSep,
        insect,
        islandDesignerBlue,
        islandDesignerBrown,
        islandDesignerGreen,
        islandNameIconsFlag,
        islandNameIconsMelody,
        landmaking,
        money,
        mydesign,
        negative,
        plant,
        shrubberyHubbery,
        smartphone,
        cooking,
        vegetable,
        hotel,
      },
    };
  },
};
